import type { BlogPost } from "./blog";

export const BLOG_EVENTS_PART1: BlogPost[] = [
  {
    "slug": "restoran-na-den-rozhdeniya-panorama-spb",
    "title": "Ресторан на день рождения с панорамным видом в СПб",
    "metaTitle": "Ресторан на день рождения с видом в СПб — Паруса на крыше",
    "metaDescription": "Ресторан с панорамным видом на Петербург для дня рождения. Скидка 20% именинникам, живая музыка, авторская кухня на 6-м этаже Olympic Plaza. Бронирование онлайн.",
    "keywords": "ресторан день рождения панорама спб, ресторан вид день рождения петербург, панорамный ресторан день рождения спб",
    "date": "2026-06-01",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Когда хочется, чтобы день рождения запомнился по-настоящему, дело не только в торте и гостях — дело в месте. Панорамный ресторан над Петербургом превращает обычный праздничный ужин в событие, о котором говорят месяцами.",
    "sections": [
      {
        "heading": "Почему вид — это главный подарок",
        "body": "Представьте: гости входят в зал, видят за панорамными окнами купола Казанского собора, золото Исаакия и бесконечную вязь петербургских крыш — и сразу понимают, что вечер будет особенным. Это происходит ещё до первого блюда и первого тоста. «Паруса на крыше» на 6-м этаже Olympic Plaza (ул. Марата, 5) работают с 2009 года и за это время стали местом, куда Петербург приходит отмечать главное. Рейтинг 5,0 на Яндекс Картах при 2 606 отзывах — цифра, которая говорит сама за себя.",
        "list": [
          "Панорама 300° на исторический центр: Казанский собор, крыши, Нева",
          "6-й этаж Olympic Plaza — один из лучших обзорных ресторанов города",
          "Работает с 2009 года: 15+ лет репутации для особых событий",
          "Рейтинг 5,0 на Яндекс Картах — «Хорошее место 2026»"
        ]
      },
      {
        "heading": "Скидка 20% и подарки именинникам",
        "body": "В «Парусах» именинникам дарят скидку 20% на весь счёт. Важный нюанс: она действует не только в сам день рождения, но и в течение 7 дней до и 7 дней после. Это удобно — можно выбрать вечер, когда удобно всем гостям, не привязываясь к конкретной дате. К скидке прилагаются персональное поздравление от команды и небольшой сюрприз от шефа. Оплата по акции — наличными, активируется при бронировании: достаточно сообщить о дне рождения заранее.",
        "highlight": "Скидка 20% действует 7 дней до и 7 дней после дня рождения. Обязательно упомяните это при бронировании по телефону +7 (812) 991-10-90 или онлайн."
      },
      {
        "heading": "Форматы праздника: от столика до банкета",
        "body": "Ресторан вмещает компании любого размера. Уютный ужин на двоих-четверых — столик у панорамного окна с видом на закат. Компания 10–30 человек — выделенная зона с отдельным обслуживанием и возможностью пригласить ведущего или живую музыку. Торжество на 50–300 гостей — банкетный зал с профессиональной сценой, светом и звуком. Банкетное меню начинается от 2 500 ₽/чел., включая закуски, горячее и десерт. Алкоголь — отдельно, карта вин на любой вкус.",
        "list": [
          "До 4 человек — столик у панорамного окна, без минимального заказа",
          "10–30 человек — приватная зона, живая музыка по запросу",
          "До 300 гостей — полный банкет, сцена, звук, свет",
          "Банкетное меню от 2 500 ₽/чел., бизнес-ланч от 590 ₽"
        ]
      },
      {
        "heading": "Как забронировать: шаги",
        "body": "Бронирование через сайт занимает 2 минуты. Для банкета удобнее позвонить на +7 (812) 991-10-90 — менеджер подберёт зал и меню под ваши задачи. При бронировании сообщите: дата, количество гостей, формат (ужин или банкет), наличие дня рождения. Для дат с живой музыкой — проверьте <a href=\"/afisha\" class=\"underline text-accent\">афишу</a>, чтобы совпасть с концертом. Рекомендуем бронировать за 1–2 недели, в праздничные периоды — за 3–4 недели."
      }
    ],
    "cta": {
      "text": "Забронировать стол на день рождения",
      "href": "/den-rozhdeniya"
    }
  },
  {
    "slug": "gde-otmetit-30-let-peterburg-restoran",
    "title": "Где отметить 30 лет в Петербурге: ресторан с видом на город",
    "metaTitle": "Где отметить 30 лет в Петербурге — ресторан с видом | Паруса на крыше",
    "metaDescription": "Где отметить 30 лет в Санкт-Петербурге? Ресторан «Паруса на крыше» — панорама города, авторская кухня, живая музыка, скидка 20% именинникам. Бронирование онлайн.",
    "keywords": "где отметить 30 лет петербург ресторан, отметить 30 лет спб, ресторан 30 лет день рождения петербург",
    "date": "2026-06-01",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Тридцать лет — рубеж, который хочется отметить по-особенному. Не просто вкусным ужином, а вечером, который останется в памяти надолго. Петербург для этого создан идеально — а ресторан на его крыше делает праздник незабываемым.",
    "sections": [
      {
        "heading": "Почему 30 лет — это повод для особого места",
        "body": "Тридцатилетие — один из тех дней рождения, которые отмечают иначе, чем обычные. Круглая цифра, пора зрелости, момент, когда хочется осмыслить прошлое и встретить будущее. Именно поэтому место имеет значение. «Паруса на крыше» — ресторан, который петербуржцы выбирают для главных событий жизни уже 15 лет. На 6-м этаже Olympic Plaza (ул. Марата, 5) открывается панорама, которая сама по себе становится частью праздника: купола, крыши, огни вечернего города.",
        "list": [
          "Рейтинг 5,0 на Яндекс Картах — «Хорошее место 2026»",
          "15+ лет работы — место знает, как сделать праздник",
          "Авторская кухня с блюдами от 490 ₽, средний чек ≈ 1 300 ₽",
          "Живая музыка по пятницам и субботам"
        ]
      },
      {
        "heading": "Форматы для тридцатилетия",
        "body": "Всё зависит от того, как вы хотите отметить этот день. Камерный ужин на 4–8 близких — столик с видом на закат, авторская кухня и неспешный разговор. Вечеринка на 15–30 человек — выделенная зона с отдельным обслуживанием, возможность пригласить ведущего или заказать живую музыку. Большой праздник на 50–100 гостей — банкетный зал с профессиональной сценой. Каждый формат поддерживается командой ресторана: менеджер помогает выстроить программу вечера от первого тоста до финального десерта."
      },
      {
        "heading": "Скидка именинникам: как получить",
        "body": "Для именинников действует скидка 20% на весь счёт — в течение 7 дней до и после дня рождения. Для компании из 15 человек со средним чеком 1 500 ₽/чел. это экономия около 4 500 ₽ — деньги, которые можно потратить на украшение зала или дополнительные блюда. Главное — сообщить о скидке при бронировании, оплата по акции производится наличными.",
        "highlight": "Скидка 20% — 7 дней до и после дня рождения. Экономия на компании из 20 человек составит около 6 000 ₽. Бронировать: +7 (812) 991-10-90."
      },
      {
        "heading": "Что заказать: лучшие блюда для праздника",
        "body": "Для торжества рекомендуем попробовать фирменные блюда на хоспере — мраморная говядина и рёбра с дымным ароматом угля. Из закусок — карпаччо из говядины, гребешки с цветной капустой и икрой. Для финала — авторский десерт от шефа. Полное <a href=\"/menu\" class=\"underline text-accent\">меню ресторана</a> доступно онлайн. Банкетное меню можно согласовать заранее — от 2 500 ₽/чел."
      }
    ],
    "cta": {
      "text": "Забронировать столик на 30-летие",
      "href": "/den-rozhdeniya"
    }
  },
  {
    "slug": "gde-otmetit-40-let-spb-restoran",
    "title": "Где отметить 40 лет в СПб: ресторан для настоящего юбилея",
    "metaTitle": "Где отметить 40 лет в СПб — ресторан Паруса на крыше",
    "metaDescription": "40 лет — юбилей, который требует особого места. Ресторан «Паруса на крыше»: панорама Петербурга, авторская кухня, банкетный зал до 300 гостей. Скидка 20%.",
    "keywords": "где отметить 40 лет спб ресторан, отметить 40 лет день рождения спб, юбилей 40 лет ресторан петербург",
    "date": "2026-06-01",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Сорок лет — момент, когда хочется не просто поужинать с друзьями, а создать настоящее событие. Ресторан на крыше Петербурга — место, которое само по себе становится главным подарком вечера.",
    "sections": [
      {
        "heading": "Сорок лет: другой масштаб праздника",
        "body": "К сорокалетию, как правило, приходят с более широким кругом гостей, чем к тридцати: коллеги, старые друзья, родные. Это значит, что нужно место, которое комфортно вмещает компанию и при этом создаёт нужную атмосферу. «Паруса на крыше» (ул. Марата, 5, 6-й этаж Olympic Plaza) справляются с этим одновременно — панорамный зал с видом на Казанский собор и Неву создаёт атмосферу, а профессиональная команда берёт на себя весь сервис. Рейтинг 5,0 на Яндекс Картах при 2 606 отзывах — не случайность, а следствие 15 лет отработанного подхода к праздникам.",
        "list": [
          "Вместимость до 300 гостей — подходит для масштабного юбилея",
          "Отдельный банкетный зал с профессиональной сценой и светом",
          "Менеджер помогает выстроить программу от приветствия до финала",
          "Банкетное меню от 2 500 ₽/чел. — несколько вариантов на выбор"
        ]
      },
      {
        "heading": "Что включить в программу сорокалетия",
        "body": "Идеальный сценарий юбилея на 40 лет в «Парусах»: cocktail hour с видом на город, за которым гости собираются и знакомятся. Затем — сидячий ужин с авторским меню и живой музыкой в фоне. После горячего — тосты и официальная часть. Финал — десертный стол, торт и неформальное общение под джаз. Живую музыку можно заказать отдельно: ресторан сотрудничает с петербургскими джазовыми исполнителями, которые часто выступают на площадке."
      },
      {
        "heading": "Скидка и специальные условия для юбиляра",
        "body": "Скидка 20% на счёт именинника действует 7 дней до и после дня рождения. Для юбилея на 40–50 человек с чеком 1 500 ₽/чел. это реальная экономия порядка 12 000–15 000 ₽. Дополнительно можно заказать украшение зала: живые цветы, фотозону с видом на Петербург, персональные карточки меню. Всё это согласовывается с менеджером при бронировании.",
        "highlight": "Для юбилея от 30 гостей рекомендуем звонить за 3–4 недели: +7 (812) 991-10-90. Менеджер подберёт зал и меню под ваш бюджет."
      },
      {
        "heading": "Почему гости выбирают именно «Паруса»",
        "body": "Петербуржцы, которые отмечали юбилеи в «Парусах», в отзывах чаще всего выделяют три вещи: вид, который производит впечатление на всех без исключения гостей; кухню, которая не разочаровывает; и сервис, который держит уровень на протяжении всего вечера. Почитать реальные отзывы можно на <a href=\"/\" class=\"underline text-accent\">странице ресторана</a>. А если хотите сравнить варианты — читайте статью о <a href=\"/blog/restorany-s-vidom-na-peterburg\" class=\"underline text-accent\">ресторанах с видом на Петербург</a>."
      }
    ],
    "cta": {
      "text": "Забронировать зал на юбилей",
      "href": "/banket"
    }
  },
  {
    "slug": "gde-otmetit-50-let-yubilej-peterburg",
    "title": "Где отметить 50 лет юбилей в Петербурге: идеи и рестораны",
    "metaTitle": "Где отметить 50 лет юбилей в Петербурге — Паруса на крыше",
    "metaDescription": "50 лет — особый юбилей. Ресторан «Паруса на крыше»: банкетный зал до 300 гостей, панорама города, живая музыка. Скидка 20% именинникам в СПб.",
    "keywords": "где отметить 50 лет юбилей петербург, юбилей 50 лет ресторан спб, отметить 50 лет петербург",
    "date": "2026-06-01",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Пятидесятилетие — юбилей особого масштаба. Это не просто день рождения, это событие, которое собирает всю жизнь за одним столом: родных, друзей, коллег. Место должно соответствовать этому масштабу.",
    "sections": [
      {
        "heading": "50 лет — это другой формат праздника",
        "body": "Пятидесятилетие обычно собирает большие компании: 50, 80, иногда 100 человек. Это уже не ресторанный ужин в привычном смысле — это полноценное мероприятие с программой, тостами, живой музыкой и несколькими переменами блюд. «Паруса на крыше» (ул. Марата, 5, Olympic Plaza) специально оборудованы для таких событий: банкетный зал вмещает до 300 гостей, есть профессиональная сцена, звуковое и световое оборудование. А панорамный вид на исторический центр Петербурга создаёт атмосферу, которую не купить ни за какие деньги.",
        "list": [
          "Банкетный зал до 300 гостей с профессиональной сценой",
          "Звук, свет, экран — полное оснащение для мероприятия",
          "Банкетное меню от 2 500 ₽/чел. (несколько вариантов)",
          "Менеджер мероприятий помогает выстроить программу вечера"
        ]
      },
      {
        "heading": "Что особенного в юбилее на крыше Петербурга",
        "body": "Вид из «Парусов» — это отдельный аргумент. На 6-м этаже Olympic Plaza открывается одна из лучших панорам центра Петербурга: купола Казанского собора на уровне взгляда, крыши и шпили, Нева вдали. Когда гости входят в зал и видят это — разговоры сами по себе смолкают на мгновение. Этот момент первого впечатления становится общим воспоминанием всего вечера. Ресторан работает с 2009 года, рейтинг 5,0 на Яндекс Картах при более чем 2 600 отзывах — репутация заслуженная."
      },
      {
        "heading": "Программа юбилея: как выстроить вечер",
        "body": "Типичная структура юбилея на 50 лет в «Парусах»: прием гостей с коктейлем (30–40 минут), общее фото с видом на Петербург, переход к сидячему ужину, тосты и выступления, живая музыка между подачами блюд, торт и заключительная часть. Ресторан помогает скоординировать тайминг: менеджер работает с вашим ведущим или сам рекомендует проверенного тамаду. Живая музыка — джаз, классика или эстрада — по запросу.",
        "highlight": "Для юбилея от 50 человек рекомендуем звонить за 4–6 недель: +7 (812) 991-10-90. В пиковые даты (декабрь, март, майские) зал бронируется особенно быстро."
      },
      {
        "heading": "Скидка и бонусы юбиляру",
        "body": "Именинник получает скидку 20% на весь счёт — действует 7 дней до и после юбилея. Для ужина на 60 человек с чеком 2 500 ₽/чел. экономия составит около 30 000 ₽. Дополнительно можно заказать живые цветы, фотозону с видом на Петербург, именное меню и персональное поздравление от шеф-повара. Подробнее о форматах банкетов читайте в статье <a href=\"/blog/gde-otmetit-den-rozhdeniya-v-peterburge\" class=\"underline text-accent\">о праздниках в ресторане на крыше</a>."
      }
    ],
    "cta": {
      "text": "Обсудить юбилей с менеджером",
      "href": "/banket"
    }
  },
  {
    "slug": "den-rozhdeniya-10-chelovek-restoran-spb",
    "title": "Ресторан для дня рождения на 10 человек в СПб",
    "metaTitle": "День рождения на 10 человек в ресторане СПб — Паруса на крыше",
    "metaDescription": "Ресторан для небольшой компании на день рождения в Петербурге. Столик с видом, авторская кухня, скидка 20% именинникам. Бронирование онлайн.",
    "keywords": "день рождения 10 человек ресторан спб, ресторан небольшая компания день рождения петербург, день рождения 10 человек спб",
    "date": "2026-06-02",
    "category": "Особые поводы",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Небольшая компания — самый уютный формат праздника. Десять человек — это когда все друг друга знают, разговор течёт свободно, а выбор места становится особенно важным: атмосфера должна работать на каждого.",
    "sections": [
      {
        "heading": "Чем хорош камерный формат",
        "body": "Компания из 10 человек — идеальный размер для настоящего праздника. Все слышат друг друга, все участвуют в разговоре, и при этом достаточно людей, чтобы вечер был живым. В «Парусах на крыше» для такой компании отлично подходит угловой столик у панорамного окна — с видом на купола Казанского собора и вечерние крыши Петербурга. Это не банкет, а именно ужин: неспешный, тёплый, с вкусной едой и разговорами.",
        "list": [
          "Угловой стол с видом — бронируется при указании пожелания",
          "Отдельное меню для именинника — скидка 20% на его счёт",
          "Средний чек ≈ 1 300–1 500 ₽/чел. без алкоголя",
          "Возможность принести торт — уточняйте при бронировании"
        ]
      },
      {
        "heading": "Что заказать для компании 10 человек",
        "body": "Для небольшой компании удобнее всего заказывать блюда à la carte — каждый выбирает сам, и это добавляет расслабленности вечеру. Из закусок для стола хорошо подходят карпаччо, гребешки и брускетты — их удобно делить. Горячее — хоспер-блюда или паста, которые здесь делают особенно хорошо. На финал — авторские десерты и, конечно, торт именинника."
      },
      {
        "heading": "Как сделать вечер особенным без лишних затрат",
        "body": "Даже без специальной программы ужин на 10 человек в «Парусах» становится событием — это происходит само по себе за счёт места. Если хочется добавить акцентов: попросите украсить стол свечами (входит в стоимость при заказе заранее), выберите вечер с живой музыкой по расписанию афиши, закажите именное меню с именем именинника.",
        "highlight": "Для компании 10 человек рекомендуем бронировать за 5–7 дней, в выходные — за 10–14 дней. Телефон: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать стол на 10 человек",
      "href": "/den-rozhdeniya"
    }
  },
  {
    "slug": "den-rozhdeniya-20-chelovek-restoran-peterburg",
    "title": "Ресторан для дня рождения на 20 человек в Петербурге",
    "metaTitle": "День рождения на 20 человек в ресторане Петербург — Паруса на крыше",
    "metaDescription": "Ресторан для дня рождения на 20 человек в СПб. Выделенная зона с видом, авторская кухня, возможность заказать живую музыку. Скидка 20% именинникам.",
    "keywords": "день рождения 20 человек ресторан петербург, ресторан 20 человек спб, банкет 20 человек петербург",
    "date": "2026-06-02",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Двадцать человек — это уже не просто ужин, но ещё не полноценный банкет. Золотая середина: достаточно людей для настоящего праздника, и при этом сохраняется та личная атмосфера, которую теряют большие мероприятия.",
    "sections": [
      {
        "heading": "Формат для 20 гостей в «Парусах»",
        "body": "Для компании из 20 человек ресторан выделяет отдельную зону — несколько сдвинутых столов с общим обслуживанием. Персональный официант работает только с вашей группой, блюда подаются одновременно для всего стола. Если хотите более банкетный формат — есть возможность организовать фуршетный стол для начала вечера, а затем перейти к сидячему ужину. Панорамные окна и вид на Петербург остаются для всех гостей — это главный аргумент, который не нужно дополнительно объяснять.",
        "list": [
          "Выделенная зона с отдельным официантом для группы",
          "Синхронная подача блюд для всего стола",
          "Возможность заказать живую музыку или ведущего",
          "Банкетное меню от 2 500 ₽/чел. или à la carte"
        ]
      },
      {
        "heading": "Организация программы вечера",
        "body": "Двадцать человек — оптимальный размер для тостов и небольшой неформальной программы. Можно пригласить ведущего на 1–2 часа для самого активного периода, а остальное время оставить для свободного общения. Живая музыка вписывается в этот формат отлично: квартет или дуэт создают атмосферу, не заглушая разговоров. Уточняйте расписание музыкантов в разделе «Афиша» — если попасть на плановый концерт, живая музыка войдёт в вечер органично и без дополнительных затрат."
      },
      {
        "heading": "Бюджет и скидка именинника",
        "body": "Средний бюджет вечера для 20 человек à la carte — от 30 000 до 50 000 ₽ в зависимости от выбора блюд и алкоголя. Банкетное меню за 2 500 ₽/чел. даст фиксированную сумму в 50 000 ₽ с понятным набором блюд. Скидка 20% на счёт именинника действует 7 дней до и после дня рождения — при чеке именинника в 3 000 ₽ экономия составит 600 ₽, но при банкете с фуршетом и тостами — значительно больше.",
        "highlight": "Для группы 20+ человек рекомендуем бронировать за 2 недели. Бесплатная консультация по программе: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать зону на 20 человек",
      "href": "/banket"
    }
  },
  {
    "slug": "den-rozhdeniya-30-chelovek-restoran-spb",
    "title": "Ресторан для дня рождения на 30 человек в СПб: банкет с видом",
    "metaTitle": "День рождения на 30 человек в ресторане СПб — Паруса на крыше",
    "metaDescription": "Банкет на 30 человек в день рождения в Петербурге. Отдельный зал с видом на Казанский собор, живая музыка, профессиональное обслуживание. Скидка 20%.",
    "keywords": "день рождения 30 человек ресторан спб, банкет 30 человек петербург, ресторан 30 человек день рождения",
    "date": "2026-06-02",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Тридцать гостей — это полноценный банкет. Масштаб, где уже нужна продуманная организация: зал, меню, программа. В «Парусах на крыше» это отработано до деталей — и делается красиво.",
    "sections": [
      {
        "heading": "Тридцать гостей: что это значит логистически",
        "body": "При 30 гостях нужна выделенная площадь с расстановкой столов под вашу задачу: единый большой стол, несколько круглых или классический банкет с фуршетной зоной. В «Парусах» есть отдельное банкетное пространство, которое настраивается под конкретное мероприятие. Окна дают вид на исторический центр Петербурга — Казанский собор, крыши, Нева вдали. Этот вид вписывается в любой дизайн оформления зала и становится лучшей декорацией, которую не нужно покупать.",
        "list": [
          "Отдельный зал с расстановкой под вашу задачу",
          "Вместимость от 30 до 100 гостей в банкетном варианте",
          "Банкетное меню от 2 500 ₽/чел. — три варианта на выбор",
          "Профессиональная подача блюд с синхронизацией по тостам"
        ]
      },
      {
        "heading": "Что включить в программу на 30 гостей",
        "body": "Для тридцати человек программа вечера структурируется сама собой: cocktail hour при входе, рассадка и аперитив, первые тосты, закуски, горячее, паузы с живой музыкой или выступлением ведущего, торт и финальный десертный стол. Весь этот сценарий легко реализуется в «Парусах» — менеджер помогает расписать тайминг с точностью до 15 минут. Живая музыка — джазовый дуэт или трио — создаёт нужный звуковой фон на протяжении всего вечера."
      },
      {
        "heading": "Стоимость и планирование",
        "body": "Банкет на 30 человек с банкетным меню в 2 500 ₽/чел. — это 75 000 ₽ за еду. Добавьте алкоголь (примерно 30–40% от стоимости еды), живую музыку при необходимости и украшение зала. Итого бюджет мероприятия обычно складывается в диапазоне 100 000–150 000 ₽. Скидка 20% на счёт именинника частично компенсирует расходы.",
        "highlight": "Бронирование банкетного зала для 30 гостей — минимум за 3 недели. Выходные и праздничные даты — за 4–5 недель. Звоните: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Обсудить банкет на 30 человек",
      "href": "/banket"
    }
  },
  {
    "slug": "banket-den-rozhdeniya-peterburg-ceny",
    "title": "Банкет на день рождения в Петербурге: цены и форматы 2026",
    "metaTitle": "Банкет на день рождения в Петербурге — цены 2026 | Паруса на крыше",
    "metaDescription": "Сколько стоит банкет на день рождения в Петербурге? Цены, форматы, что входит. Ресторан «Паруса на крыше» — банкетное меню от 2 500 ₽/чел.",
    "keywords": "банкет день рождения петербург цены, стоимость банкета день рождения спб, банкетное меню день рождения петербург",
    "date": "2026-06-02",
    "category": "Особые поводы",
    "readTime": 8,
    "image": "/photos/food.webp",
    "lead": "«Сколько стоит банкет на день рождения в Петербурге?» — вопрос, который задают в первую очередь. Ответ зависит от формата, количества гостей и ресторана. Разбираем по-честному: что входит в цену, где можно сэкономить и на чём нельзя.",
    "sections": [
      {
        "heading": "Из чего складывается стоимость банкета",
        "body": "Цена банкета — это не одна цифра, а сумма нескольких составляющих: аренда зала или площадки (в ряде ресторанов входит в стоимость при минимальном заказе), банкетное меню на человека, алкоголь, программа (ведущий, музыканты), украшение зала. В «Парусах на крыше» аренда зала не взимается отдельно при банкетном заказе — платите только за меню и дополнительные услуги. Это делает расчёт прозрачным: взяли меню за 2 500 ₽/чел., умножили на количество гостей, добавили алкоголь и программу.",
        "list": [
          "Банкетное меню: от 2 500 ₽/чел. (несколько вариантов)",
          "Аренда зала: включена при заказе банкетного меню",
          "Алкоголь: ≈ 700–1 200 ₽/чел. в зависимости от выбора",
          "Живая музыка: по запросу, уточняется отдельно",
          "Украшение стола: часть опций бесплатно для именинника"
        ]
      },
      {
        "heading": "Примеры бюджетов для разных компаний",
        "body": "Компания 20 человек с банкетным меню 2 500 ₽/чел. — это 50 000 ₽ за еду. Добавьте 15 000–20 000 ₽ на алкоголь — итого 65 000–70 000 ₽. Компания 50 человек — 125 000 ₽ за еду + 35 000–50 000 ₽ на алкоголь = 160 000–175 000 ₽. При этом стоимость живой музыки (дуэт на 3 часа) обычно составляет 30 000–50 000 ₽. Эти суммы характерны для панорамного ресторана с авторской кухней в центре Петербурга — и соответствуют рынку."
      },
      {
        "heading": "Как снизить стоимость банкета без потери качества",
        "body": "Несколько рабочих приёмов: выбирайте будний вечер — во многих ресторанах это даёт более гибкие условия. Используйте скидку 20% именинника — 7 дней до и после даты. Откажитесь от ведущего в пользу живой музыки — это дешевле и часто атмосфернее. Для небольших компаний (до 20 человек) à la carte нередко выходит дешевле фиксированного банкетного меню.",
        "highlight": "Скидка 20% на счёт именинника при наличных — один из главных инструментов экономии. Сообщите о дне рождения при бронировании."
      },
      {
        "heading": "На что обратить внимание при выборе зала",
        "body": "Кроме цены — смотрите на три вещи: вместимость (комфортная плотность гостей = 1,5–2 кв.м/чел.), технические возможности (есть ли микрофон, экран, точки питания для ноутбука ведущего), и главное — атмосферу. Никакое украшение не заменит вид из окна. В «Парусах» этот вид — панорама Петербурга с 6-го этажа — и есть главный актив. Подробнее о банкетных возможностях — на <a href=\"/banket\" class=\"underline text-accent\">странице банкетов</a>."
      }
    ],
    "cta": {
      "text": "Узнать цены на банкет",
      "href": "/banket"
    }
  },
  {
    "slug": "den-rozhdeniya-zhivaya-muzyka-restoran-peterburg",
    "title": "День рождения с живой музыкой в ресторане Петербурга",
    "metaTitle": "День рождения с живой музыкой в ресторане Петербурга — Паруса",
    "metaDescription": "Ресторан с живой музыкой для дня рождения в Санкт-Петербурге. Джаз и авторские выступления, панорама города, авторская кухня. Скидка 20% именинникам.",
    "keywords": "день рождения живая музыка ресторан петербург, ресторан живая музыка день рождения спб, день рождения джаз петербург",
    "date": "2026-06-02",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Живая музыка на дне рождения — это не просто фон. Это переключение атмосферы, момент, когда разговоры стихают и все слушают. В правильном ресторане музыка и кухня работают вместе, создавая вечер, который запоминается целиком.",
    "sections": [
      {
        "heading": "Почему живая музыка меняет всё",
        "body": "Исследования в области сенсорного маркетинга показывают: живая музыка повышает воспринимаемое качество еды и удовольствие от вечера на 15–20%. Это не субъективное ощущение, а измеримый эффект. В «Парусах на крыше» живая музыка — постоянная часть программы: джазовые исполнители, квартеты и вокальные дуэты регулярно выступают в ресторане. Расписание публикуется в разделе «Афиша» — при планировании дня рождения просто выберите вечер с выступлением.",
        "list": [
          "Живая музыка по расписанию — джаз, классика, вокал",
          "Возможность заказать отдельное выступление для вашего вечера",
          "Музыканты работают как фон, не перебивая разговоры",
          "Панорама города + живая музыка = атмосфера, которую не создать искусственно"
        ]
      },
      {
        "heading": "Как совместить музыку и программу дня рождения",
        "body": "Для камерного ужина на 8–12 человек живая музыка выступает фоном весь вечер — дуэт или трио играет между подачами блюд, замолкает во время тостов. Для банкета на 30–50 человек удобнее разделить вечер: первая половина — музыканты создают атмосферу, вторая — официальная часть с тостами, после — снова музыка. Ресторан помогает скоординировать тайминг с музыкантами."
      },
      {
        "heading": "Что слушают на днях рождения в «Парусах»",
        "body": "Самый популярный формат — джазовый дуэт (рояль + вокал) или трио. Репертуар: мировой джаз-стандарты, французская шансон, русская эстрада в джазовой аранжировке. Это работает для любого возраста и состава компании. Если хотите что-то другое — авторскую программу или конкретный жанр — это обсуждается при заказе. Ресторан сотрудничает с несколькими петербургскими музыкальными коллективами.",
        "highlight": "Проверьте афишу перед бронированием — в вечер концерта вход без дополнительной оплаты. Бронирование: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Проверить расписание музыки",
      "href": "/afisha"
    }
  },
  {
    "slug": "restoran-den-rozhdeniya-tort-spb",
    "title": "Ресторан на день рождения с тортом в СПб: как это устроить",
    "metaTitle": "Ресторан на день рождения с тортом в СПб — Паруса на крыше",
    "metaDescription": "Можно ли принести торт в ресторан на день рождения в Петербурге? Как заказать торт от шефа? Ответы и советы от «Парусов на крыше».",
    "keywords": "ресторан день рождения торт спб, принести торт в ресторан петербург, торт именинникам ресторан спб",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Вопрос про торт — один из самых частых при планировании дня рождения в ресторане. Можно ли принести свой? Сделают ли торт в ресторане? Как организовать этот момент так, чтобы он запомнился? Отвечаем честно.",
    "sections": [
      {
        "heading": "Свой торт или от ресторана: за и против",
        "body": "В «Парусах на крыше» допускается принести торт от внешней кондитерской — при условии предварительного согласования. Это нужно уточнять при бронировании: ресторан может взимать символическую плату за сервировку (нарезка, тарелки, вилки). Альтернатива — торт от шефа ресторана: авторский десерт, стилизованный под событие, с персональной надписью. Стоимость и варианты обсуждаются при заказе. Большинство гостей, которые планируют запоминающийся момент разрезания торта, выбирают именно вариант от шефа: он красиво оформлен и идеально сочетается с остальными блюдами вечера.",
        "list": [
          "Свой торт — допускается при предварительном согласовании",
          "Торт от шефа — авторский, с надписью, стилизован под событие",
          "Сервировка торта: торжественный вынос под музыку по запросу",
          "Уточнять при бронировании: +7 (812) 991-10-90"
        ]
      },
      {
        "heading": "Момент разрезания торта: как сделать его особенным",
        "body": "Многие пары и именинники хотят сделать момент с тортом запоминающимся. В «Парусах» это легко организовать: торжественный вынос торта со свечами, «Happy Birthday» от музыкантов (если есть живая музыка), общее фото на фоне панорамы Петербурга. Это занимает 10–15 минут и становится одним из главных кадров вечера. Заранее предупредите официанта и попросите зафиксировать момент на телефон — сотрудники ресторана охотно помогают."
      },
      {
        "heading": "Советы по планированию торта на день рождения",
        "body": "Если берёте внешний торт: заказывайте в проверенной кондитерской с доставкой к началу вечера, учитывайте размер (на 10 человек — торт 1,5–2 кг). Если заказываете у ресторана: обсудите дизайн и надпись минимум за 3–5 дней. В обоих случаях — сообщите ресторану о торте при бронировании, чтобы подготовили сервировку и продумали момент выноса.",
        "highlight": "Персональная свеча и «Happy Birthday» от сотрудников ресторана — всегда бесплатно для именинника. Просто скажите при бронировании."
      }
    ],
    "cta": {
      "text": "Забронировать стол на день рождения",
      "href": "/den-rozhdeniya"
    }
  },
  {
    "slug": "korporativ-restoran-spb",
    "title": "Корпоратив в ресторане Санкт-Петербурга: где провести в 2026",
    "metaTitle": "Корпоратив в ресторане Санкт-Петербурга 2026 — Паруса на крыше",
    "metaDescription": "Где провести корпоратив в ресторане Санкт-Петербурга? «Паруса на крыше» — банкетный зал до 300 гостей, панорама города, авторская кухня. Банкетное меню от 2 500 ₽/чел.",
    "keywords": "корпоратив ресторан санкт-петербург, корпоратив в ресторане спб, где провести корпоратив петербург ресторан",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 8,
    "image": "/photos/interior.webp",
    "lead": "Корпоратив в ресторане — это не просто ужин командой. Это инструмент укрепления отношений, который при правильном выборе места работает на компанию ещё долго после окончания вечера. Выбор ресторана в этом случае — стратегическое решение.",
    "sections": [
      {
        "heading": "Почему место корпоратива важно для бренда компании",
        "body": "Корпоратив транслирует ценности компании так же, как офис или сайт. Ресторан на крыше с панорамой Петербурга говорит: «мы ценим своих людей и хотим дать им лучшее». Это формирует лояльность эффективнее, чем любой HR-инструмент. «Паруса на крыше» (ул. Марата, 5, 6-й этаж Olympic Plaza) — выбор компаний, которые понимают эту связь. Рейтинг 5,0 на Яндекс Картах при 2 606 отзывах означает, что место стабильно выполняет обещания.",
        "list": [
          "Банкетный зал до 300 гостей с профессиональной сценой",
          "Отдельный вход и выделенная парковка для гостей мероприятия",
          "Менеджер мероприятий — бесплатная координация программы",
          "Банкетное меню от 2 500 ₽/чел. с несколькими вариантами"
        ]
      },
      {
        "heading": "Форматы корпоративных мероприятий",
        "body": "Деловой обед для команды (10–30 человек): обед à la carte в выделенной зоне, без официальной программы. Корпоративный ужин с программой (30–100 человек): банкетный формат с ведущим, живой музыкой, тостами и вручением наград или подарков. Масштабный корпоратив (100–300 гостей): полное мероприятие со сценой, шоу-программой, фуршетом и сидячим ужином. Каждый формат реализуем в «Парусах» — менеджер помогает выбрать оптимальный."
      },
      {
        "heading": "Что включить в корпоративную программу",
        "body": "Для команды 30–50 человек оптимальная программа: cocktail hour с видом на Петербург (30 минут), сидячий ужин с тостами руководителя (1,5–2 часа), награждение лучших сотрудников или розыгрыш призов (30 минут), живая музыка и свободное общение (1–1,5 часа). Этот формат работает: создаёт ощущение праздника без утомительной «обязательной программы».",
        "highlight": "Ноябрь–декабрь — самые востребованные месяцы для корпоративов. Бронируйте заранее, в июне-сентябре: +7 (812) 991-10-90."
      },
      {
        "heading": "Сколько стоит корпоратив в «Парусах»",
        "body": "Базовый расчёт: банкетное меню 2 500 ₽ × количество гостей + алкоголь (30–40% от стоимости еды) + программа при необходимости. Корпоратив на 40 человек: 100 000 ₽ за меню + 35 000–40 000 ₽ на алкоголь = 135 000–140 000 ₽. Для сравнения: аналогичный по формату ресторан в центре Петербурга без панорамного вида стоит сопоставимо, но эффект на команду — несравнимо ниже. Подробнее о возможностях читайте на <a href=\"/korporativ\" class=\"underline text-accent\">странице корпоративов</a>."
      }
    ],
    "cta": {
      "text": "Обсудить корпоратив с менеджером",
      "href": "/korporativ"
    }
  },
  {
    "slug": "korporativ-na-20-chelovek-restoran-spb",
    "title": "Корпоратив на 20 человек в ресторане СПб: форматы и цены",
    "metaTitle": "Корпоратив на 20 человек в ресторане СПб — Паруса на крыше",
    "metaDescription": "Организовать корпоратив на 20 человек в Петербурге. Выделенная зона с видом, банкетное меню, живая музыка. Расчёт стоимости и форматы мероприятия.",
    "keywords": "корпоратив 20 человек ресторан спб, корпоратив небольшой коллектив петербург, ресторан 20 человек корпоратив",
    "date": "2026-06-03",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Двадцать человек — комфортный размер для корпоратива. Достаточно людей для настоящего праздника, достаточно мало — чтобы каждый чувствовал себя частью вечера, а не гостем массового мероприятия.",
    "sections": [
      {
        "heading": "Почему 20 человек — идеальный размер",
        "body": "При двадцати участниках корпоратив сохраняет камерность: все общаются, слышат тосты, участвуют в розыгрышах. При этом масштаб достаточен для полноценной программы: ведущий, живая музыка, подарки. В «Парусах на крыше» для такой группы выделяется отдельная зона с персональным официантом. Блюда подаются синхронно всей группе — это важно для торжественной атмосферы тостов.",
        "list": [
          "Выделенная зона — только ваша команда, без посторонних",
          "Персональный официант для группы — никаких задержек",
          "Синхронная подача блюд к тостам",
          "Возможность поставить проектор или экран"
        ]
      },
      {
        "heading": "Сценарий вечера для 20 человек",
        "body": "Стандартный и проверенный формат: встреча гостей с видом на Петербург, аперитив (15–20 минут), переход к столу, слово руководителя, закуски. Затем — основная часть: горячее, тосты, небольшое награждение лучших. Финал — десерт, живая музыка, неформальное общение. Такой вечер занимает 3–4 часа и оставляет ощущение праздника без переутомления."
      },
      {
        "heading": "Бюджет корпоратива на 20 человек",
        "body": "Базовый расчёт: банкетное меню 2 500 ₽ × 20 = 50 000 ₽. Алкоголь — ориентировочно 700–1 000 ₽/чел. = 14 000–20 000 ₽. Итого еда + напитки: 64 000–70 000 ₽. Дополнительно: живая музыка (опционально), украшение зала (при необходимости). Для компании с бюджетом 80 000–100 ₽ это реалистичный и комфортный вариант корпоратива на хорошем уровне в центре Петербурга.",
        "highlight": "Минимальная сумма заказа для выделения зоны уточняется у менеджера. Звоните: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать корпоратив на 20 человек",
      "href": "/korporativ"
    }
  },
  {
    "slug": "korporativ-na-50-chelovek-peterburg",
    "title": "Корпоратив на 50 человек в Петербурге: организация и цены",
    "metaTitle": "Корпоратив на 50 человек в Петербурге — Паруса на крыше",
    "metaDescription": "Как организовать корпоратив на 50 человек в Петербурге? Банкетный зал с видом на город, профессиональная сцена, меню от 2 500 ₽/чел. Бронирование.",
    "keywords": "корпоратив 50 человек петербург, корпоратив полсотни человек спб, ресторан 50 человек корпоратив петербург",
    "date": "2026-06-04",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/interior.webp",
    "lead": "Пятьдесят человек — это уже настоящее корпоративное мероприятие с полноценной логистикой. Для такого размера нужен не просто ресторан, а площадка с правильными техническими возможностями и командой, которая умеет работать с группами.",
    "sections": [
      {
        "heading": "Технические требования для 50 гостей",
        "body": "При 50 участниках корпоратив требует: достаточной площади (минимум 75–100 кв.м для комфортного сидячего формата), микрофон и усилитель для ведущего, возможность разместить экран для презентации или видео, профессиональный звук для живой музыки. «Паруса на крыше» оснащены всем перечисленным: банкетный зал с профессиональной сценой, звуком и светом вмещает до 100 гостей в сидячем формате.",
        "list": [
          "Профессиональная сцена, звук, свет — в комплекте",
          "Микрофон для ведущего и спикеров",
          "Экран/проектор — по запросу",
          "Кейтеринг-сервис: синхронная подача блюд для всего зала"
        ]
      },
      {
        "heading": "Программа корпоратива на 50 человек",
        "body": "Оптимальная структура: cocktail hour (30–40 минут) — гости собираются, знакомятся, пьют аперитив с видом на Петербург. Официальная часть (20–30 минут): слово генерального директора, итоги года или поздравления. Сидячий ужин (2–2,5 часа): три перемены блюд, тосты, музыкальные паузы. Свободная часть (1 час): живая музыка, общение, десертный стол. Итого: 4–4,5 часа на всё мероприятие."
      },
      {
        "heading": "Бюджет и планирование",
        "body": "Банкетное меню 2 500 ₽ × 50 = 125 000 ₽. Алкоголь: 800 ₽ × 50 = 40 000 ₽. Итого еда + напитки: ≈ 165 000 ₽. При среднем бюджете компании 5 000 ₽/сотрудника на корпоратив (250 000 ₽ на 50 чел.) остаётся бюджет на программу, ведущего и оформление зала.",
        "highlight": "Корпоратив на 50 человек в декабре — бронируйте в сентябре. На другие даты — за 4–6 недель. Телефон: +7 (812) 991-10-90."
      },
      {
        "heading": "Что делает корпоратив запоминающимся",
        "body": "Для 50 человек главное — чтобы вечер «склеился»: все чувствовали себя частью одной истории. Панорама Петербурга на 6-м этаже Olympic Plaza создаёт общий контекст для всей группы — это то впечатление, которым делятся в чатах на следующий день. Больше о форматах корпоративов на <a href=\"/korporativ\" class=\"underline text-accent\">странице корпоративов ресторана</a>."
      }
    ],
    "cta": {
      "text": "Обсудить корпоратив на 50 человек",
      "href": "/korporativ"
    }
  },
  {
    "slug": "korporativ-na-kryshe-peterburg",
    "title": "Корпоратив на крыше в Петербурге: атмосфера и организация",
    "metaTitle": "Корпоратив на крыше Петербурга — Паруса на крыше | Ресторан",
    "metaDescription": "Корпоратив на крыше в Санкт-Петербурге. Панорамный ресторан «Паруса на крыше» — банкет до 300 человек, профессиональная сцена, вид на город. Бронирование.",
    "keywords": "корпоратив крыша петербург, корпоратив ресторан на крыше спб, мероприятие крыша петербург",
    "date": "2026-06-04",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_clouds.webp",
    "lead": "Корпоратив на крыше — формат, который стал символом нового подхода к командным событиям. Не просто поужинать, а увидеть свой город по-другому, встать над ним и почувствовать масштаб. Это работает на командный дух лучше любого тимбилдинга.",
    "sections": [
      {
        "heading": "Почему корпоратив «на крыше» — это не просто красиво",
        "body": "Высота создаёт другое ощущение пространства. Когда команда смотрит на Петербург с 6-го этажа Olympic Plaza, это буквально меняет перспективу. Психологи называют это «elevated mindset» — ощущение подъёма, которое люди ассоциируют с целями и достижениями. Именно поэтому корпоративы в «Парусах на крыше» особенно популярны в конце года — как подведение итогов и взгляд вперёд. Ресторан работает с 2009 года, рейтинг 5,0 на Яндекс Картах — команда знает, как принять компанию любого размера.",
        "list": [
          "Панорама 300° — Казанский собор, крыши, Нева, вечерний город",
          "Закрытая площадка — только ваша компания, нет посторонних",
          "Банкет до 300 гостей или камерный ужин для команды 10–20 человек",
          "Летом дополнительно — открытая терраса с живым воздухом"
        ]
      },
      {
        "heading": "Сезоны для корпоратива на крыше",
        "body": "Лето: открытая терраса, закаты в 22:00, белые ночи — уникальное петербургское ощущение. Осень: вид на золотые крыши, уютный закрытый зал, осенние коктейли. Зима: заснеженный Петербург с высоты, рождественские огни, глинтвейн и горячие блюда. Весна: первое тепло, ощущение обновления. Ресторан работает круглый год, закрытый зал с панорамными окнами обеспечивает вид в любую погоду."
      },
      {
        "heading": "Организация корпоратива: шаги",
        "body": "1. Определите формат (ужин или полноценный банкет с программой) и количество гостей. 2. Свяжитесь с менеджером: +7 (812) 991-10-90. 3. Обсудите дату, меню, программу и технические потребности. 4. Согласуйте и подпишите договор при необходимости. 5. Внесите предоплату для фиксации даты. Весь процесс занимает 1–2 рабочих дня при своевременном обращении.",
        "highlight": "Для корпоративов в ноябре-декабре начинайте бронирование в августе-сентябре — это самый востребованный период."
      }
    ],
    "cta": {
      "text": "Забронировать корпоратив на крыше",
      "href": "/korporativ"
    }
  },
  {
    "slug": "novogodniy-korporativ-restoran-spb",
    "title": "Новогодний корпоратив в ресторане СПб: где провести в 2025–2026",
    "metaTitle": "Новогодний корпоратив в ресторане СПб 2025-2026 — Паруса на крыше",
    "metaDescription": "Новогодний корпоратив в ресторане Санкт-Петербурга. «Паруса на крыше» — банкет до 300 человек, новогоднее меню, панорама города, живая музыка. Бронируйте заранее.",
    "keywords": "новогодний корпоратив ресторан спб, корпоратив новый год петербург, новогодний банкет ресторан спб",
    "date": "2026-06-04",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/view_night.webp",
    "lead": "Новогодний корпоратив — главное событие года для команды. То, как компания встречает Новый год, запоминается надолго. Выбор ресторана здесь определяет не просто меню, а то, каким останется этот вечер в памяти каждого.",
    "sections": [
      {
        "heading": "Почему новогодний корпоратив — это важно",
        "body": "Новогодний корпоратив — единственное мероприятие, на которое приходит вся команда одновременно. Это ежегодный ритуал, который либо сближает людей, либо воспринимается как обязанность. Разница — в уровне организации. Ресторан, который создаёт настоящую атмосферу праздника, превращает обязательное посещение в желанное. «Паруса на крыше» собирают корпоративы в конце года каждый декабрь — и знают, как сделать его особенным.",
        "list": [
          "Банкетный зал до 300 гостей с новогодним оформлением",
          "Специальное новогоднее меню — уточняйте в сезон",
          "Живая музыка: новогодняя программа или джазовый ансамбль",
          "Панорама ночного зимнего Петербурга — незабываемый вид для корпоратива"
        ]
      },
      {
        "heading": "Когда бронировать новогодний корпоратив",
        "body": "Это главный вопрос. Популярные даты — 20–28 декабря — разбираются в сентябре-октябре. Даты ближе к 31 декабря — в августе. Если хотите конкретный день и конкретный формат, оптимально выходить на бронирование в июне-августе. «Паруса на крыше» начинают принимать заявки на декабрь уже летом. Промедление означает потерю лучших дат."
      },
      {
        "heading": "Формат новогоднего корпоратива",
        "body": "Для крупных компаний (50+): cocktail reception при входе, официальная часть с поздравлением руководства, праздничный ужин с новогодним меню, живая музыка и танцевальная программа. Для небольших команд (до 30): тёплый ужин в приватной зоне, тосты, подарки, джазовый фон. В обоих случаях — вид на зимний ночной Петербург становится лучшим новогодним украшением без дополнительных затрат.",
        "highlight": "Бронирование новогодних дат (15–31 декабря) — только по телефону: +7 (812) 991-10-90. Предоплата фиксирует дату."
      },
      {
        "heading": "Сколько стоит новогодний корпоратив",
        "body": "В период новогодних праздников меню в большинстве ресторанов фиксированное и несколько дороже обычного. В «Парусах» стоимость банкетного меню на Новый год уточняется у менеджера — она зависит от конкретной даты и состава блюд. Ориентировочно: от 3 500–4 000 ₽/чел. для праздничного меню с алкоголем. Сравните с альтернативами: загородный отель (дорого + дорога), другой ресторан без вида (дешевле, но без атмосферы). Читайте также статью о <a href=\"/blog/korporativ-restoran-spb\" class=\"underline text-accent\">корпоративах в ресторане СПб</a>."
      }
    ],
    "cta": {
      "text": "Забронировать новогодний корпоратив",
      "href": "/korporativ"
    }
  },
  {
    "slug": "romanticheskiy-uzhin-peterburg-rестораны",
    "title": "Романтический ужин в Петербурге: лучшие рестораны 2026",
    "metaTitle": "Романтический ужин в Петербурге — лучшие рестораны 2026 | Паруса",
    "metaDescription": "Где устроить романтический ужин в Санкт-Петербурге? Топ ресторанов с видом, приватными столиками и особой атмосферой. Бронирование с сюрпризом.",
    "keywords": "романтический ужин петербург рестораны, романтический ужин спб, ресторан романтика петербург",
    "date": "2026-06-04",
    "category": "Романтика",
    "readTime": 8,
    "image": "/photos/view_sunset.webp",
    "lead": "Романтический ужин в Петербурге — это не сложно организовать, но легко испортить неправильным выбором места. Здесь важны детали: вид, освещение, расстояние между столами, музыка. Собрали честный гид по форматам и местам.",
    "sections": [
      {
        "heading": "Что делает ужин романтическим: честный разбор",
        "body": "Романтика создаётся несколькими факторами одновременно. Приватность — расстояние между столами, возможность говорить без того, чтобы тебя слышали соседи. Освещение — мягкое, тёплое, не яркое. Вид — что-то красивое за окном. Звук — тихая музыка, которая создаёт фон, а не конкурирует с разговором. В «Парусах на крыше» эти четыре фактора собраны вместе: угловые столики у панорамных окон с видом на закат, свечи, живой джаз вполголоса. Это не случайная комбинация, а результат 15 лет работы с гостями для особых поводов.",
        "list": [
          "Приватные угловые столики — запрашивайте при бронировании",
          "Вид на исторический центр Петербурга — меняется с часами",
          "Живая музыка вполголоса — не мешает разговору",
          "Деликатный сервис — персонал понимает, когда не нужно подходить"
        ]
      },
      {
        "heading": "Лучшее время для романтического ужина",
        "body": "Летом: ужин в 20:00–21:00 даёт золотой закат прямо за вашим столиком — и постепенный переход в сумерки белой ночи. Осенью: 18:00–19:00, когда стекает дождь и огни города отражаются в мокрых крышах. Зимой: 17:00–18:00 — сразу темнеет, и ночной зимний Петербург выглядит особенно торжественно. Весной: ужин у открытого окна или на террасе, когда первое тепло смешивается с запахом города."
      },
      {
        "heading": "Как организовать сюрприз",
        "body": "Романтический сюрприз в «Парусах» организовывается при бронировании: сообщите, что планируете сюрприз, и менеджер поможет. Стандартные опции: живые цветы на столе к приходу партнёра, шампанское от ресторана как подарок, персональная записка в меню, организация предложения руки и сердца с видом на город. Всё это делается с любовью к деталям — именно об этом пишут в отзывах.",
        "highlight": "Хотите сделать предложение? Звоните заранее: +7 (812) 991-10-90. Команда ресторана умеет делать такие моменты незабываемыми."
      },
      {
        "heading": "Сравнение форматов романтического ужина",
        "body": "Ужин на теплоходе по Неве: красиво, но шумно и нет постоянного места. Ресторан на Рубинштейна: хорошая кухня, но тесно и шумно в выходные. Загородный ресторан: уединённость, но дорога. «Паруса на крыше»: вид на город, кухня, приватность и транспортная доступность в одном месте. Подробнее о том, как спланировать вечер — в статье <a href=\"/blog/romanticheskiy-uzhin-na-kryshe-peterburga\" class=\"underline text-accent\">романтический ужин на крыше Петербурга</a>."
      }
    ],
    "cta": {
      "text": "Забронировать романтический ужин",
      "href": "/romanticheskiy-uzhin"
    }
  },
  {
    "slug": "restoran-svidanie-tsentr-spb",
    "title": "Ресторан для свидания в центре СПб: где произвести впечатление",
    "metaTitle": "Ресторан для свидания в центре СПб — Паруса на крыше",
    "metaDescription": "Ресторан для свидания в центре Санкт-Петербурга. «Паруса на крыше» — вид на город, авторская кухня, приватные столики. Первое и не первое свидание.",
    "keywords": "ресторан свидание центр спб, ресторан для свидания петербург, куда пойти на свидание спб ресторан",
    "date": "2026-06-05",
    "category": "Романтика",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Выбор ресторана для свидания — ответственное дело. Место говорит о вас до того, как вы сказали слово. Хороший ресторан снимает неловкость первых минут и создаёт тему для разговора — просто потому, что он сам по себе интересен.",
    "sections": [
      {
        "heading": "Что важно в ресторане для свидания",
        "body": "Звук: разговор должен быть возможен без повышения голоса. В «Парусах» акустика зала мягкая, музыкант играет вполголоса. Расстояние между столиками: важна хоть какая-то приватность. В ресторане столики не стоят вплотную. Вид: красивое за окном снимает паузы в разговоре — «смотри, как закат меняет цвет над куполами». Меню: достаточно разнообразное, чтобы каждый нашёл своё, без экзотики, которая смущает на первом свидании.",
        "list": [
          "Мягкая акустика — разговариваете вполголоса",
          "Приватные угловые столики у панорамных окон",
          "Вид на закат над куполами — лучший разговорный повод",
          "Авторская кухня с блюдами от 490 ₽, средний чек ≈ 1 300 ₽"
        ]
      },
      {
        "heading": "Первое свидание vs. не первое: разные задачи",
        "body": "На первом свидании нужна нейтральная территория: место, где обоим комфортно, где не нужно объяснять, что заказывать, и где можно сосредоточиться на разговоре. «Паруса» для этого подходят: ресторан достаточно особенный, чтобы показать внимание к деталям, но не настолько пафосный, чтобы создавать давление. На втором-третьем свидании — это место для «следующего шага»: специальный вечер, намеренный выбор красивого места, возможно, первый ужин при свечах."
      },
      {
        "heading": "Практические советы по выбору столика",
        "body": "При бронировании обязательно укажите, что это романтический ужин — официант поймёт и заберёт пальто, предложит шампанское, не будет лишний раз появляться рядом. Попросите столик у окна — это увеличивает шансы на красивый вид и правильный свет. Вечер пятницы или субботы даёт живую музыку в фоне без дополнительных трат.",
        "highlight": "Бронирование: онлайн за 2–3 дня или по телефону +7 (812) 991-10-90. Упомяните «романтический ужин» — персонал знает, что это значит."
      }
    ],
    "cta": {
      "text": "Забронировать столик для свидания",
      "href": "/romanticheskiy-uzhin"
    }
  },
  {
    "slug": "romanticheskiy-uzhin-na-kryshe-peterburga",
    "title": "Романтический ужин на крыше Петербурга: как это устроить",
    "metaTitle": "Романтический ужин на крыше Петербурга — Паруса на крыше",
    "metaDescription": "Романтический ужин на крыше в Петербурге. Ресторан «Паруса на крыше» — вид на исторический центр, живая музыка, авторская кухня. Как забронировать и что заказать.",
    "keywords": "романтический ужин крыша петербург, ужин на крыше петербург романтика, ресторан крыша романтика спб",
    "date": "2026-06-05",
    "category": "Романтика",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Ужин на крыше — это когда город становится частью вашего вечера. Не фоном на картинке, а живым участником: меняет цвет с закатом, зажигает огни с наступлением ночи. В Петербурге это особенно сильный эффект.",
    "sections": [
      {
        "heading": "Чем ужин на крыше отличается от обычного",
        "body": "Ресторан «Паруса на крыше» на 6-м этаже Olympic Plaza даёт то, что называют эффектом «elevated experience»: когда физически поднимаешься над городом, изменяется восприятие. Купола Казанского собора — на уровне взгляда. Крыши Центрального района — перед глазами. Нева — где-то там, за горизонтом. Этот вид меняется каждый час: дневное золото переходит в розовый закат, потом — в фиолетовые сумерки, потом — в россыпь огней ночного города. Для романтического ужина это непобедимый аргумент.",
        "list": [
          "Закат с крыши: летом 20:30–21:30, осенью 16:30–17:30",
          "Вечерняя панорама: огни Казанского собора и крыши центра",
          "Живая музыка по пятницам и субботам — добавляет атмосферу",
          "Открытая летняя терраса — ужин под открытым небом"
        ]
      },
      {
        "heading": "Что заказать для особого вечера",
        "body": "Для романтического ужина на двоих хорошо работает следующий сценарий: начать с бокала игристого и лёгкой закуски (гребешки или карпаччо). Главное блюдо — что-то тёплое и основательное: стейк на хоспере или паста с морепродуктами. Финал — авторский десерт и кофе. Не торопитесь: ужин можно растянуть на 2,5–3 часа — место к этому располагает."
      },
      {
        "heading": "Как добавить особых деталей",
        "body": "Сообщите при бронировании о поводе: годовщина, первое свидание, предложение. Ресторан поможет с деталями: живые цветы, шампанское на столе к приходу, персональная записка в меню. Если планируете предложение руки и сердца — команда знает, как создать нужный момент. Многие гости выбирают именно «Паруса» для этого события: панорама Петербурга — лучший ответ на вопрос «где».",
        "highlight": "Лучший момент для предложения: вечер пятницы или субботы в 19:00–20:00 с живой музыкой. Стол у окна с закатом — фон, который запомнится навсегда."
      },
      {
        "heading": "Цены и планирование",
        "body": "Романтический ужин для двоих в «Парусах»: ориентировочно 4 000–7 000 ₽ на двоих без алкоголя, 6 000–10 000 ₽ с вином или шампанским. Это средний уровень для панорамного ресторана в центре Петербурга. Подробнее о ценах — в статье <a href=\"/blog/sredniy-chek-restoran-peterburg\" class=\"underline text-accent\">средний чек в ресторанах Петербурга</a>. Бронирование: онлайн или по телефону +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать романтический ужин",
      "href": "/romanticheskiy-uzhin"
    }
  },
  {
    "slug": "svadba-restoran-spb-organizatsiya",
    "title": "Свадьба в ресторане Санкт-Петербурга: организация и советы",
    "metaTitle": "Свадьба в ресторане Санкт-Петербурга — Паруса на крыше | Организация",
    "metaDescription": "Как организовать свадьбу в ресторане Санкт-Петербурга? «Паруса на крыше» — свадебный банкет с видом на город, до 300 гостей, авторская кухня. Бронирование.",
    "keywords": "свадьба ресторан санкт-петербург, организация свадьбы ресторан спб, свадебный банкет петербург",
    "date": "2026-06-05",
    "category": "Свадьба",
    "readTime": 9,
    "image": "/photos/view_sunset.webp",
    "lead": "Свадьба в Петербурге — событие, достойное особого места. Город с его барочной архитектурой, куполами и панорамами создаёт декорации, которые не нужно создавать искусственно. Задача — найти ресторан, который достроит эту картину правильной кухней и сервисом.",
    "sections": [
      {
        "heading": "Ресторан или загородная усадьба: что выбрать",
        "body": "Главный выбор перед свадьбой в Петербурге — рестораны или загородные усадьбы. Усадьба даёт пространство, природу и возможность большой гуляния, но добавляет сложность с логистикой (трансфер, размещение). Ресторан в городе — это транспортная доступность, профессиональный сервис, готовая кухня и заложенная в место атмосфера. «Паруса на крыше» — это второй вариант в максимальном проявлении: ресторан в историческом центре, панорамный вид на Петербург и инфраструктура для события до 300 гостей.",
        "list": [
          "Свадебный банкет до 300 гостей — банкетный зал с полным оснащением",
          "Профессиональная сцена, звук, свет — в комплекте",
          "Менеджер мероприятий — координация всей программы",
          "Авторская кухня: банкетное меню от 2 500 ₽/чел."
        ]
      },
      {
        "heading": "Свадебное меню: как выбрать",
        "body": "Свадебное меню — баланс между разнообразием и исполнимостью для большой группы. В «Парусах» предлагают несколько вариантов банкетного меню, адаптированных под свадьбу: фуршетный стол на cocktail hour, затем — сидячий ужин с 2–3 переменами блюд. Важно: обсудите специальное вегетарианское меню для тех гостей, которым оно нужно, — ресторан легко это организует."
      },
      {
        "heading": "Оформление зала: что возможно",
        "body": "В «Парусах» можно заказать декоративное оформление через партнёров ресторана или принести своё — флористические арки, гирлянды, вазы. Главное: вид из окон уже является декорацией, которую не нужно создавать. Свадебный стол с видом на Казанский собор и ночной Петербург — это снимок, который войдёт в свадебный альбом без дополнительных усилий фотографа.",
        "highlight": "Для свадьбы на 50+ гостей рекомендуем обсудить дату и формат минимум за 3–4 месяца. Лучшие летние даты разбираются в феврале-марте. Телефон: +7 (812) 991-10-90."
      },
      {
        "heading": "Выездная регистрация и банкет: можно ли совместить",
        "body": "Да, «Паруса» работают с выездными регистрациями: процедура проходит в зале ресторана, после чего гости остаются на банкет. Это удобный формат — не нужно никуда переезжать. Нотариус или официальный регистратор приезжает в ресторан. Подробнее о свадебных форматах — на <a href=\"/svadba\" class=\"underline text-accent\">странице свадеб в ресторане</a>."
      }
    ],
    "cta": {
      "text": "Обсудить свадьбу с менеджером",
      "href": "/svadba"
    }
  },
  {
    "slug": "svadebnyy-banket-krysha-peterburg",
    "title": "Свадебный банкет на крыше в Петербурге: всё что нужно знать",
    "metaTitle": "Свадебный банкет на крыше Петербурга — Паруса на крыше",
    "metaDescription": "Свадебный банкет на крыше в Санкт-Петербурге. Панорама исторического центра, банкет до 300 гостей, авторская кухня. Всё о организации свадебного торжества.",
    "keywords": "свадебный банкет крыша петербург, свадьба на крыше спб, банкет на крыше свадьба петербург",
    "date": "2026-06-05",
    "category": "Свадьба",
    "readTime": 8,
    "image": "/photos/view_summer.webp",
    "lead": "Свадебный банкет на крыше — мечта многих пар, но не всегда понятно, что именно скрывается за этим словосочетанием. Разбираем, что реально предлагает Петербург в этом формате и как организовать день, который запомнится на всю жизнь.",
    "sections": [
      {
        "heading": "Что такое свадьба «на крыше» в Петербурге",
        "body": "«Крыша» в контексте свадьбы — это ресторан на верхних этажах с панорамными окнами или открытой террасой. «Паруса на крыше» (6-й этаж Olympic Plaza, ул. Марата, 5) предлагают оба варианта: закрытый зал с панорамными видами — для свадьбы в любой сезон, и открытую террасу — для летних торжеств. Вид на исторический центр Петербурга с куполами Казанского собора создаёт декорации, которые не купить ни за какие деньги.",
        "list": [
          "Закрытый зал с панорамой — доступен круглый год",
          "Открытая терраса — летом, в хорошую погоду",
          "Вместимость: до 300 гостей (банкет), до 150 (сидячий ужин)",
          "Оформление зала — в партнёрстве с флористами"
        ]
      },
      {
        "heading": "Фотосессия на свадьбе: что даёт вид из окна",
        "body": "Свадебная фотосессия на фоне панорамы Петербурга — это кадры, которые не нужно «создавать» — они получаются сами. Пара у окна с Казанским собором на фоне, первый танец с ночными огнями города за стеклом, групповое фото с крышами Петербурга — всё это входит в свадебный альбом и становится его центральными кадрами."
      },
      {
        "heading": "Летняя свадьба на открытой террасе",
        "body": "Летом в «Парусах» открывается терраса — ужин под открытым небом с видом на Петербург. Для свадьбы это означает: cocktail hour на свежем воздухе после регистрации, первый танец с небом Петербурга над головой, вечерний банкет в переходе от белой ночи к сумеркам. Это один из самых запоминающихся форматов в городе.",
        "highlight": "Летние даты (июнь-август) — самые востребованные для свадеб. Бронируйте минимум за 4–6 месяцев. Телефон: +7 (812) 991-10-90."
      },
      {
        "heading": "Стоимость свадебного банкета на крыше",
        "body": "Базовый расчёт свадебного банкета: банкетное меню от 2 500 ₽/чел. × количество гостей + алкоголь. Свадьба на 50 гостей: ≈ 125 000–160 000 ₽ за еду и напитки. Свадьба на 100 гостей: ≈ 250 000–320 000 ₽. Дополнительно: живая музыка, оформление, ведущий, торт. Эти цифры — рыночный уровень для панорамного ресторана в центре Петербурга. Больше об организации свадьбы — на <a href=\"/svadba\" class=\"underline text-accent\">странице свадебных предложений</a>."
      }
    ],
    "cta": {
      "text": "Обсудить свадебный банкет",
      "href": "/svadba"
    }
  },
  {
    "slug": "devichnik-restoran-spb",
    "title": "Девичник в ресторане Санкт-Петербурга: идеи и форматы",
    "metaTitle": "Девичник в ресторане Санкт-Петербурга — Паруса на крыше | Идеи",
    "metaDescription": "Где провести девичник в ресторане Санкт-Петербурга? «Паруса на крыше» — приватная зона, авторская кухня, живая музыка, панорама города. Идеи для незабываемого девичника.",
    "keywords": "девичник ресторан санкт-петербург, девичник спб ресторан, где провести девичник спб",
    "date": "2026-06-06",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Девичник — особый вечер, который должен быть только для своих. Правильный ресторан здесь не просто место для ужина, а сцена для воспоминаний, которые останутся у всей компании.",
    "sections": [
      {
        "heading": "Что важно для девичника в ресторане",
        "body": "Ключевые требования к ресторану для девичника: приватность — отдельная зона или закрытый зал, чтобы компания была сама по себе. Атмосфера — место, где хочется остаться надолго, а не поужинать и уйти. Кухня — разнообразная, с лёгкими вариантами и хорошим выбором напитков. «Паруса на крыше» отвечают всем трём критериям: выделенная зона с панорамой Петербурга, авторская кухня и персональный официант для группы.",
        "list": [
          "Выделенная зона — только ваша компания, без соседей",
          "Панорама Петербурга — идеальный фон для фото",
          "Карта коктейлей и вин — несколько вариантов на любой вкус",
          "Персональный официант — внимание без лишнего присутствия"
        ]
      },
      {
        "heading": "Идеи для девичника на крыше Петербурга",
        "body": "Дегустация вин: менеджер ресторана может организовать мини-дегустацию — 4–5 бокалов разных вин с краткой историей каждого. Коктейльный вечер: бармен готовит авторские коктейли для группы — каждой своё. Фотосессия на фоне панорамы: закат или ночной Петербург за окном — лучший фон без аренды фотостудии. Просто ужин с разговорами: иногда лучший девичник — это просто красивое место и время без расписания."
      },
      {
        "heading": "Как организовать",
        "body": "Бронируйте за 1–2 недели и сообщите, что это девичник и примерное количество человек. Уточните, хотите ли дегустацию или коктейльную программу — это организуется заранее. Если планируете шампанское для встречи невесты — согласуйте с ресторанм при бронировании.",
        "highlight": "Компания 6–12 человек — идеальный размер для девичника в «Парусах». Для большей группы (15+) — выделяется отдельный банкетный зал."
      }
    ],
    "cta": {
      "text": "Забронировать девичник",
      "href": "/den-rozhdeniya"
    }
  },
  {
    "slug": "delovoy-obed-spb-rестораны",
    "title": "Деловой обед в Санкт-Петербурге: лучшие рестораны 2026",
    "metaTitle": "Деловой обед в Санкт-Петербурге — лучшие рестораны 2026 | Паруса",
    "metaDescription": "Где провести деловой обед в Санкт-Петербурге? «Паруса на крыше» — панорамный ресторан для бизнес-встреч, деловых ужинов и переговоров. Бизнес-ланч от 590 ₽.",
    "keywords": "деловой обед санкт-петербург рестораны, деловой обед спб, ресторан переговоры петербург",
    "date": "2026-06-06",
    "category": "Особые поводы",
    "readTime": 7,
    "image": "/photos/interior.webp",
    "lead": "Деловой обед — это переговоры в другом формате. Место создаёт контекст: правильный ресторан располагает к открытому разговору, неправильный — отвлекает и создаёт напряжение. Выбор ресторана для деловой встречи — часть подготовки к переговорам.",
    "sections": [
      {
        "heading": "Что делает ресторан подходящим для деловых встреч",
        "body": "Три критерия: 1. Звуковой комфорт — в ресторане не должно быть фонового шума, который заглушает разговор. В «Парусах» акустика зала деликатная, живая музыка — не главное, а фон. 2. Сервис — официанты понимают формат деловой встречи: не мешают разговору, подходят только когда нужно. 3. Статус места — ресторан с видом на Петербург и рейтингом 5,0 говорит о качестве стандартами без слов.",
        "list": [
          "Деловой бизнес-ланч от 590 ₽ — будни, 12:00–16:00",
          "Отдельные зоны для приватного разговора",
          "Центральное расположение: ул. Марата 5, шаговая доступность метро",
          "Вид на Казанский собор — нейтральная тема для начала разговора"
        ]
      },
      {
        "heading": "Форматы деловых встреч в «Парусах»",
        "body": "Быстрый деловой ланч (1–1,5 часа): бизнес-ланч за 590 ₽, лёгкое меню, эффективно и без затяжки. Деловой обед для обсуждения партнёрства (2 часа): à la carte, неспешно, можно заказать отдельный столик. Деловой ужин с гостями из другого города (2–3 часа): авторская кухня, впечатляющий вид — ресторан сам по себе становится аргументом в вашу пользу. Переговоры для нескольких сторон: приватная зона или отдельный зал с минимальным заказом."
      },
      {
        "heading": "Почему именно «Паруса»",
        "body": "Когда вы приглашаете партнёра в «Паруса на крыше», вы говорите: «я знаю лучшие места в городе». Это работает как сигнал статуса. Ресторан с 15-летней историей, рейтингом 5,0 и видом на исторический центр Петербурга — выбор человека, который разбирается. При этом бизнес-ланч от 590 ₽ делает этот выбор доступным для регулярных встреч.",
        "highlight": "Для регулярных деловых обедов рекомендуем сообщить об этом при первом посещении — персонал запомнит ваши предпочтения."
      }
    ],
    "cta": {
      "text": "Забронировать деловой обед",
      "href": "/"
    }
  },
  {
    "slug": "vypusknoy-restoran-spb",
    "title": "Выпускной в ресторане Санкт-Петербурга: идеи и организация",
    "metaTitle": "Выпускной в ресторане Санкт-Петербурга — Паруса на крыше | 2026",
    "metaDescription": "Где провести выпускной в ресторане Санкт-Петербурга? «Паруса на крыше» — банкет с видом на город, живая музыка, авторская кухня. Идеи для незабываемого выпускного.",
    "keywords": "выпускной ресторан санкт-петербург, выпускной вечер спб ресторан, ресторан для выпускного петербург",
    "date": "2026-06-06",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_summer.webp",
    "lead": "Выпускной — один из главных вечеров в жизни. Место, где вы его проведёте, войдёт в историю — буквально. Через 10 лет все будут помнить не речи, а атмосферу: где были, что видели, как себя чувствовали.",
    "sections": [
      {
        "heading": "Почему ресторан лучше кафе на выпускной",
        "body": "Выпускной — повод для взрослого формата. Ресторан вместо кафе говорит о том, что момент значим: ты закончил школу или институт, и это событие заслуживает лучшего. «Паруса на крыше» — выбор для тех, кто хочет, чтобы выпускной выглядел как событие, а не как стандартная вечеринка в аренду. Вид на Петербург с 6-го этажа Olympic Plaza — идеальный фон для первых взрослых фотографий.",
        "list": [
          "Вид на исторический центр — лучший фон для выпускных фотографий",
          "Живая музыка по расписанию или по запросу",
          "Банкетные форматы для группы 20–100 человек",
          "Банкетное меню от 2 500 ₽/чел."
        ]
      },
      {
        "heading": "Что включить в программу выпускного",
        "body": "Выпускной в «Парусах» строится по следующей схеме: встреча компании с фото на фоне Петербурга (аперитив, 30 минут), переход к столу, тосты от выпускников и родителей (если есть), ужин с 2–3 переменами блюд, живая музыка или DJ во второй половине вечера, десертный стол и торт с поздравительной надписью. Этот сценарий работает как для школьного выпускного, так и для защиты диплома."
      },
      {
        "heading": "Советы по организации",
        "body": "Кто платит: при групповом выпускном удобно заранее договориться о сборе — банкетное меню за 2 500 ₽/чел. делает расчёт прозрачным. Что включить в меню: для молодёжи хорошо работают лёгкие закуски, горячее и разнообразный десертный стол. Алкоголь: строго 18+, меню включает безалкогольные коктейли для всей группы.",
        "highlight": "Июнь — самый востребованный месяц для выпускных. Бронируйте в апреле-мае, чтобы выбрать лучшую дату. Телефон: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать выпускной вечер",
      "href": "/banket"
    }
  },
  {
    "slug": "novogodniy-uzhin-restoran-peterburg",
    "title": "Новогодний ужин в ресторане Петербурга: как провести 31 декабря",
    "metaTitle": "Новогодний ужин в ресторане Петербурга — Паруса на крыше",
    "metaDescription": "Новогодний ужин в ресторане Санкт-Петербурга. «Паруса на крыше» — новогоднее меню, живая музыка, панорама ночного города. Бронирование на 31 декабря.",
    "keywords": "новогодний ужин ресторан петербург, ужин новый год спб, ресторан 31 декабря петербург",
    "date": "2026-06-06",
    "category": "Особые поводы",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Новогодняя ночь в ресторане — выбор тех, кто хочет провести её красиво, не готовя сам и не беспокоясь об организации. Ресторан на крыше добавляет к этому панораму праздничного города — фейерверки с высоты, огни и куполами под вами.",
    "sections": [
      {
        "heading": "Встреча Нового года в ресторане: форматы",
        "body": "В «Парусах на крыше» встреча Нового года организуется в нескольких форматах. Романтический ужин для двоих — столик у окна, новогоднее меню, шампанское в полночь, панорама ночного Петербурга. Дружеский ужин (4–10 человек) — выделенная зона, фиксированное меню, живая музыка. Корпоративный Новый год (20–300 человек) — полный банкет с программой, ведущим и живой музыкой.",
        "list": [
          "31 декабря — особое новогоднее меню и программа",
          "Панорама на ночной Петербург и фейерверки с высоты",
          "Живая музыка: новогодний репертуар",
          "Шампанское на двоих или на стол — в подарок от ресторана"
        ]
      },
      {
        "heading": "Почему Новый год лучше встречать на высоте",
        "body": "В полночь 31 декабря Петербург зажигает фейерверки — их видно с 6-го этажа Olympic Plaza одновременно в нескольких направлениях. Шампанское, праздничное меню, живая музыка и панорама салютов над городом — это новогодняя атмосфера, которую не создать дома никакими стараниями."
      },
      {
        "heading": "Бронирование и стоимость",
        "body": "Новогодние столики разбирают в сентябре-октябре. Стоимость новогоднего меню уточняется у менеджера — она всегда выше обычного, но включает праздничный сет, бутылку шампанского и программу. Для корпоративного Нового года фиксируйте дату в июле-августе.",
        "highlight": "31 декабря — самая востребованная дата года. Бронировать только по телефону: +7 (812) 991-10-90. Предоплата обязательна."
      }
    ],
    "cta": {
      "text": "Узнать о новогодней программе",
      "href": "/afisha"
    }
  },
  {
    "slug": "gde-svodit-devushku-na-svidanie-spb",
    "title": "Где сводить девушку на свидание в СПб: идеи и рестораны",
    "metaTitle": "Где сводить девушку на свидание в СПб — Паруса на крыше | 2026",
    "metaDescription": "Куда сходить с девушкой на свидание в Петербурге? «Паруса на крыше» — панорамный ресторан, авторская кухня, живая музыка. Идеальное место для любого свидания.",
    "keywords": "куда сходить с девушкой спб свидание, где сводить девушку свидание петербург, свидание спб где",
    "date": "2026-06-07",
    "category": "Романтика",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "Вопрос «куда сводить девушку в Петербурге?» — один из самых гуглимых в городе. И правильно: от выбора места зависит настроение вечера. Разбираем, что работает, а что нет.",
    "sections": [
      {
        "heading": "Критерии правильного места для свидания",
        "body": "Место для свидания должно решать три задачи: убирать неловкость первых минут (красивый вид, необычная обстановка дают тему для разговора), создавать атмосферу (освещение, музыка, расстояние между столиками), и не мешать общению (не слишком шумно, не слишком тесно). «Паруса на крыше» справляются со всеми тремя. Вид на купола Казанского собора — лучший начало разговора. Живой джаз вполголоса — правильная атмосфера. Угловые столики — достаточно приватно.",
        "list": [
          "Первый взгляд на вид — снимает неловкость первых минут",
          "Живая музыка — создаёт атмосферу без усилий",
          "Авторская кухня — есть о чём говорить",
          "Средний чек ≈ 1 300–1 500 ₽/чел. — разумно для свидания"
        ]
      },
      {
        "heading": "Первое свидание в «Парусах»: что ожидать",
        "body": "Вы входите в лифт Olympic Plaza, поднимаетесь на 6-й этаж. Двери открываются — и перед вами Петербург. Казанский собор на уровне взгляда, крыши центра, в дальней перспективе — Нева. Это «вау-момент», который запускает вечер правильно. Дальше — авторская кухня с приятными ценами (блюда от 490 ₽), внимательный сервис и живая музыка, если повезёт с днём недели."
      },
      {
        "heading": "Практические советы",
        "body": "Пятница и суббота — живая музыка в ресторане по расписанию. Лучший столик — угловой у панорамного окна (запрашивайте заранее). Оптимальное время: летом — 19:30–20:00, чтобы застать закат; зимой — 17:00, чтобы увидеть, как город зажигает огни. Бронировать за 2–3 дня, в выходные — за 5–7 дней.",
        "highlight": "Для особого вечера: шампанское к приходу девушки — закажите при бронировании. Это стоит недорого и производит большое впечатление."
      }
    ],
    "cta": {
      "text": "Забронировать столик для свидания",
      "href": "/romanticheskiy-uzhin"
    }
  },
  {
    "slug": "pervoe-svidanie-restoran-peterburg",
    "title": "Ресторан для первого свидания в Петербурге: как не ошибиться",
    "metaTitle": "Ресторан для первого свидания в Петербурге — Паруса на крыше",
    "metaDescription": "Какой ресторан выбрать для первого свидания в Петербурге? Советы и идеи от «Парусов на крыше» — панорамный ресторан для особого первого впечатления.",
    "keywords": "первое свидание ресторан петербург, ресторан первая встреча спб, куда пойти на первое свидание петербург",
    "date": "2026-06-07",
    "category": "Романтика",
    "readTime": 7,
    "image": "/photos/interior.webp",
    "lead": "Первое свидание — единственная встреча, первое впечатление от которой нельзя повторить. Ресторан для первого свидания должен работать на вас, а не против вас. Вот что это означает на практике.",
    "sections": [
      {
        "heading": "Ошибки при выборе ресторана на первое свидание",
        "body": "Слишком дорогой ресторан: создаёт давление с обеих сторон, человек чувствует себя обязанным. Слишком шумное место: разговор невозможен — а первое свидание это прежде всего разговор. Модное место с очередью: раздражение от ожидания убивает настроение. Нейтральное кафе: хорошо, но не создаёт атмосферы. Идеальный баланс — место особенное, но не пафосное, тихое, но не унылое. «Паруса на крыше» находятся именно в этой точке.",
        "list": [
          "Не слишком дорого: средний чек ≈ 1 300 ₽/чел.",
          "Не шумно: акустика зала позволяет говорить вполголоса",
          "Не нужно ждать: бронирование заранее снимает проблему",
          "Особенное: вид на Петербург создаёт атмосферу сам по себе"
        ]
      },
      {
        "heading": "Почему вид работает на первое свидание",
        "body": "На первом свидании всегда есть паузы — моменты, когда разговор прерывается и нужна тема. Вид из «Парусов» решает эту проблему: «Смотри, как меняется цвет неба над куполами». «А ты знаешь, что это за шпиль вдали?» «Посмотри, как город зажигает огни». Эти моменты — не неловкая пауза, а часть вечера."
      },
      {
        "heading": "Как подготовиться к первому свиданию в ресторане",
        "body": "Забронируйте столик заранее — это говорит о том, что вы серьёзно подошли к встрече. Попросите столик у окна при бронировании. Придите на 5–10 минут раньше — встретите партнёра уже за столом, это снимает организационный стресс. Позвольте официанту помочь с выбором — можно сказать «что посоветуете попробовать?» и это превращается в тему для разговора.",
        "highlight": "Небольшой лайфхак: заранее узнайте о живой музыке в этот вечер — если есть выступление, упомяните это при приглашении. Это создаёт ожидание."
      }
    ],
    "cta": {
      "text": "Забронировать стол для первого свидания",
      "href": "/romanticheskiy-uzhin"
    }
  },
  {
    "slug": "kuda-pojti-vecherom-vdvoem-peterburg",
    "title": "Куда пойти вечером вдвоём в Петербурге: идеи и рестораны",
    "metaTitle": "Куда пойти вечером вдвоём в Петербурге 2026 — Паруса на крыше",
    "metaDescription": "Куда пойти вечером вдвоём в Петербурге? «Паруса на крыше» — ужин с видом на город, живая музыка, авторская кухня. Идеи для особого вечера вдвоём.",
    "keywords": "куда пойти вечером вдвоём петербург, куда пойти вечером паре спб, вечер вдвоём петербург",
    "date": "2026-06-07",
    "category": "Романтика",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Вечер вдвоём в Петербурге — это всегда особый разговор. Город создаёт фон, который не нужно выстраивать: огни, мосты, купола и крыши. Вопрос только в том, где именно провести этот вечер, чтобы он запомнился.",
    "sections": [
      {
        "heading": "Варианты вечера для пары в Петербурге",
        "body": "Театр или концерт + ужин после: культурный формат, хорошо работает для пар, которые уже встречаются. Прогулка по набережной + ужин: бесплатно и романтично, но зависит от погоды. Ресторан с видом: комфортно в любое время года, без зависимости от погоды, с хорошей кухней. «Паруса на крыше» — лучший вариант третьего формата в Петербурге: вид, кухня и атмосфера в одном месте.",
        "list": [
          "Ужин с видом на Петербург — работает в любую погоду",
          "Живая музыка по пятницам-субботам — без дополнительного билета",
          "Авторская кухня — есть о чём говорить во время ужина",
          "От центра города — 5–10 минут пешком от Невского"
        ]
      },
      {
        "heading": "Идеальный вечер вдвоём: как выстроить",
        "body": "Прогулка по центру Петербурга → ужин в «Парусах» с видом на закат → живая музыка → десерт и кофе → вечерняя прогулка по набережной. Этот маршрут занимает 4–5 часов и даёт полный «петербургский опыт» для пары. Можно сделать проще: просто прийти к 19:00, выбрать столик у окна и провести вечер без расписания."
      },
      {
        "heading": "Практические детали",
        "body": "Ресторан находится в 5 минутах пешком от станций метро Маяковская и Достоевская. Парковка у Olympic Plaza. Бронирование: онлайн или по телефону +7 (812) 991-10-90, занимает 2 минуты. Средний счёт для пары — 2 600–4 000 ₽ в зависимости от выбора блюд и напитков.",
        "highlight": "Пятница и суббота — живая музыка. Проверьте афишу перед бронированием — добавит атмосферы без лишних затрат."
      }
    ],
    "cta": {
      "text": "Забронировать вечер для двоих",
      "href": "/romanticheskiy-uzhin"
    }
  },
  {
    "slug": "uzhin-pri-svechah-restoran-spb",
    "title": "Ужин при свечах в ресторане СПб: романтический вечер с видом",
    "metaTitle": "Ужин при свечах в ресторане СПб — Паруса на крыше | Романтика",
    "metaDescription": "Романтический ужин при свечах в ресторане Санкт-Петербурга. «Паруса на крыше» — свечи, вид на город, живая музыка, авторская кухня. Бронирование с сюрпризом.",
    "keywords": "ужин при свечах ресторан спб, ужин свечи романтика петербург, романтический ужин свечи спб",
    "date": "2026-06-07",
    "category": "Романтика",
    "readTime": 5,
    "image": "/photos/view_sunset.webp",
    "lead": "Свечи на столе — это не просто освещение. Это сигнал: этот вечер особенный. В правильном ресторане свечи плюс вид из окна создают атмосферу, которую невозможно повторить дома.",
    "sections": [
      {
        "heading": "Ужин при свечах в «Парусах на крыше»",
        "body": "В «Парусах» свечи на столе — стандарт для вечернего сервиса. Это сочетается с мягким освещением зала и живым огнём на столах создаёт тот особый свет, который делает лица красивее и разговоры — откровеннее. Добавьте к этому вид на ночной Петербург в панорамных окнах — и вы получаете атмосферу, которую в других ресторанах создают специальными вечерами, а здесь — каждый обычный вечер.",
        "list": [
          "Свечи на столах — стандарт вечернего сервиса",
          "Мягкое тёплое освещение зала",
          "Вид на ночной Петербург — дополнительный источник «света»",
          "Живая музыка вполголоса — полная атмосфера"
        ]
      },
      {
        "heading": "Что заказать для ужина при свечах",
        "body": "Для особого вечера хорошо работает следующая последовательность: аперитив — бокал игристого или авторский коктейль. Закуска — что-то лёгкое: карпаччо, гребешки или брускетта. Горячее — тёплое, основательное: стейк или паста. Десерт — обязательно: авторский десерт от шефа с кофе. Не торопитесь — правильный романтический ужин при свечах длится 2,5–3 часа."
      },
      {
        "heading": "Как заказать свечи и украшение стола",
        "body": "При бронировании сообщите, что планируете романтический ужин — этого достаточно. Дополнительно можно заказать: живые цветы на стол, шампанское к приходу партнёра, персональную записку в меню. Всё согласовывается заранее. Если планируете предложение — об этом тоже говорите при бронировании: команда знает, как сделать момент незабываемым.",
        "highlight": "Бронирование: онлайн или +7 (812) 991-10-90. Обязательно укажите «романтический ужин» в комментарии к брони."
      }
    ],
    "cta": {
      "text": "Забронировать романтический ужин",
      "href": "/romanticheskiy-uzhin"
    }
  },
  {
    "slug": "gde-sdelat-predlozhenie-spb-restoran",
    "title": "Где сделать предложение руки и сердца в СПб: идеи в ресторане",
    "metaTitle": "Где сделать предложение руки и сердца в СПб — Паруса на крыше",
    "metaDescription": "Где сделать предложение в Санкт-Петербурге? «Паруса на крыше» — панорама города, приватные столики, поддержка от команды ресторана. Идеи для незабываемого момента.",
    "keywords": "где сделать предложение спб ресторан, предложение руки сердца петербург, сделать предложение ресторан спб",
    "date": "2026-06-08",
    "category": "Романтика",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Предложение руки и сердца — один из самых важных моментов в жизни. Место, где это происходит, входит в семейную историю навсегда. Рассказываем, как организовать этот момент в «Парусах на крыше» — и почему это работает.",
    "sections": [
      {
        "heading": "Почему ресторан на крыше — идеальное место для предложения",
        "body": "Петербург + высота + живая музыка + вид на купола = идеальная сцена. Когда за окном разворачивается панорама исторического центра, а вы опускаетесь на одно колено, это не просто момент — это кадр, который останется в памяти навсегда. «Паруса на крыше» за 15 лет работы стали местом, где делают предложения — команда ресторана знает, как помочь и не помешать.",
        "list": [
          "Угловой столик у панорамного окна — запрашивайте специально",
          "Команда ресторана знает сценарий и поддержит момент",
          "Живые цветы, шампанское, фото — всё организовывается заранее",
          "Вид на Петербург — лучший фон для «да»"
        ]
      },
      {
        "heading": "Как организовать предложение в ресторане",
        "body": "Шаг 1: Забронируйте столик у окна и сообщите, что планируете предложение. Шаг 2: Обсудите с менеджером детали: живые цветы на столе? Шампанское в момент «да»? Фотограф в зале? Шаг 3: Приходите раньше партнёра на 10–15 минут — проверьте стол, передайте кольцо официанту или шефу (они сохранят), успокоитесь. Шаг 4: Выберите момент между переменами блюд — когда ничего не мешает разговору."
      },
      {
        "heading": "Что заказать для особого вечера",
        "body": "Для вечера предложения выбирайте блюда, которые вы оба любите — не время для экспериментов. Начните с аперитива и закуски, основное блюдо — тёплое и основательное. Предложение — в момент ожидания десерта или с его появлением. Шампанское — сразу после «да», как сигнал для всего зала (если хотите — это можно организовать и как тихий момент только для двоих).",
        "highlight": "Хотите, чтобы фотограф зафиксировал момент? Это можно организовать: свяжитесь заранее, ресторан посоветует проверенного фотографа."
      },
      {
        "heading": "Истории из «Парусов»",
        "body": "За 15 лет работы ресторана здесь было сделано немало предложений — и почти каждое сопровождалось одним и тем же: видом на Петербург за окном и живой музыкой вполголоса. Именно этот фон делает момент запоминающимся не только для пары, но и для тех, кто видит это со стороны. Подробнее о романтических вечерах — в статье <a href=\"/blog/romanticheskiy-uzhin-na-kryshe-peterburga\" class=\"underline text-accent\">романтический ужин на крыше Петербурга</a>."
      }
    ],
    "cta": {
      "text": "Организовать особый вечер",
      "href": "/romanticheskiy-uzhin"
    }
  },
  {
    "slug": "godovshchina-otnosheny-restoran-spb",
    "title": "Ресторан для годовщины отношений в СПб: как отметить красиво",
    "metaTitle": "Ресторан для годовщины отношений в СПб — Паруса на крыше",
    "metaDescription": "Где отметить годовщину отношений в Петербурге? «Паруса на крыше» — романтический ужин с видом на город, живая музыка, авторская кухня.",
    "keywords": "годовщина отношений ресторан спб, отметить годовщину петербург ресторан, ресторан годовщина свидание спб",
    "date": "2026-06-08",
    "category": "Романтика",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "Годовщина — это не просто повтор первого свидания. Это момент, когда хочется отметить то, что было, и встретить то, что будет. Место для этого должно быть достаточно особенным, чтобы почувствовать разницу с обычным вечером.",
    "sections": [
      {
        "heading": "Почему годовщину важно отмечать в особом месте",
        "body": "Исследования в области психологии отношений показывают: совместный особый опыт («peak experience») укрепляет связь сильнее, чем обычные приятные вечера. Ужин в особом месте с красивым видом и хорошей кухней — именно такой опыт. «Паруса на крыше» дают его по умолчанию: вид, который каждый раз немного другой (закат меняется, сезон меняется), авторская кухня, которая эволюционирует вместе с меню.",
        "list": [
          "Годовщина за тем же столиком, что и первое свидание — создаёт традицию",
          "Каждый раз другой вид: другой сезон, другое время суток",
          "Авторское меню обновляется — есть что пробовать снова",
          "Скидка 20% на годовщину свадьбы — уточните условия"
        ]
      },
      {
        "heading": "Как сделать годовщину особенной",
        "body": "Маленькие детали, которые работают: забронируйте тот же столик, что в прошлый раз (или впервые — выберите «свой»). Закажите то блюдо, которое было в первый вечер — или то, которое хотели попробовать. Попросите шампанское к приходу партнёра как сюрприз. Сделайте фото в том же месте — серия «годовщин» превращается в красивую традицию."
      },
      {
        "heading": "Цены и планирование",
        "body": "Ужин для двоих на годовщину: средний счёт 4 000–8 000 ₽ в зависимости от выбора блюд и вина. Это разумная сумма для особого вечера, который повторяется раз в год. Бронируйте за 3–5 дней. Для годовщины свадьбы — уточните специальные условия у менеджера.",
        "highlight": "Скажите при бронировании «годовщина» — персонал добавит свечи и подготовится сделать вечер особенным. Телефон: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Забронировать ужин на годовщину",
      "href": "/romanticheskiy-uzhin"
    }
  }
];
